import moment from "moment";

export function toStandardDateTime(value) {
  if (value) {
    return moment(String(value)).format("DD-MMM-YYYY HH:mm:ss  Z");
  }
  return value;
}
